import { useState } from "react";
import Image from "next/image";
import { CreditCardPaymentMethod } from "@/types/membership";

const SubscriptionDetails = (props: {
  id: string;
  nextBill: string;
  payment: CreditCardPaymentMethod;
}) => {

  const [isSuccess, setIsSuccess] = useState(false)
  const changePaymentMethod = async () => {
    setIsSuccess(false);
    fetch('/api/updateMembershipPaymentMethod', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Accept': '*/*'
      },
      body: JSON.stringify({
        contractId: props.id,
      })
    })
      .then(async (res) => {
        if (res.status === 200) {
          setIsSuccess(true);
        }
      })
      .catch((err) => {
        setIsSuccess(false);
        console.log(err);
      })
  };

  return (
    <div className="flex flex-col mt-10 lg:mt-1">
      <p>Subscription ID: {props.id}</p>
      <div className="flex flex-col border border-silver w-full mt-7 p-5">
        <p >Next bill: {new Date(props.nextBill).toLocaleDateString('en-US', { timeZone: 'America/New_York' })}</p>
        <div className="my-2 mr-3">
          <div className="flex flex-row items-center">
            <Image
              src="/icons/creditcard.svg"
              className="mr-2"
              alt="Credit Card"
              width={15}
              height={15}
            />
            <p className="ml-3">{props.payment.brand} ending in {props.payment.lastDigits}</p>
          </div>
        </div>
        <div className='ml-5 mt-2 cursor-pointer' onClick={() => changePaymentMethod()}>
          <a className="uppercase underline">
            Change Card
          </a>
        </div>
      </div>
      {
        isSuccess && <div className='flex flex-row mt-4 items-center'>
          <Image
            src="/icons/green-check-mark.svg"
            alt="Correct"
            width={12}
            height={9}
          />
          <p className='font-normal text-base text-mint ml-4'>Check your email for the link to update your payment method</p>
        </div>
      }
    </div>
  )
};

export default SubscriptionDetails;
